import { render, staticRenderFns } from "./table-super-tag.vue?vue&type=template&id=856d7a4a"
import script from "./table-super-tag.vue?vue&type=script&lang=js"
export * from "./table-super-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports